module.exports = __webpack_public_path__ + "img/default_img.6d8b9142.jpg";